const CAMBODIA_MOBILE_PREFIXES = new Set([
  '010', '011', '012', '014', '015', '016', '017', '018',
  '031', '060', '061', '066', '067', '068', '069', '070',
  '071', '076', '077', '078', '081', '085', '086', '087',
  '088', '089', '090', '092', '093', '095', '096', '097',
  '098', '099',
])

export const checkPhoneNumber = phone => {
  if (!phone?.toString().trim()) return 0

  let normalizedPhone = phone.toString().replace(/[\s().-]/g, '')

  if (normalizedPhone.startsWith('+855')) {
    normalizedPhone = `0${normalizedPhone.slice(4)}`
  } else if (normalizedPhone.startsWith('855')) {
    normalizedPhone = `0${normalizedPhone.slice(3)}`
  }

  if (!/^0\d+$/.test(normalizedPhone)) return 1

  const prefix = normalizedPhone.slice(0, 3)
  // if (!CAMBODIA_MOBILE_PREFIXES.has(prefix)) return 1

  return normalizedPhone.length === 9 || normalizedPhone.length === 10 ? 0 : 1
}

/** Required fields: 0 valid, 1 invalid format/length, 2 empty. */
export const checkRequiredPhoneNumber = phone => {
  if (!phone?.toString().trim()) return 2
  return checkPhoneNumber(phone)
}
